import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-monitoring-table',
  templateUrl: './monitoring-table.component.html',
  styleUrls: ['./monitoring-table.component.css']
})
export class MonitoringTableComponent {
  @Input() isMonitoringPage: boolean = true;
  @Input() responseData: any[] = [];
  @Input() responseTotal: any = {};
  @Input() selectedProject: any[] = [];
  @Input() totAziendali: any;

  @Input() totUserForPage: number;
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Input() pageSize: number;
  @Input() currentPage: number = 1;

  isLoading: boolean = false;
  sortKey: string = '';
  sortValue: string = '';
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktop: boolean = false;

  listOfColumn = [
    {
      title: 'Utenti',
      compare: (userA: any, userB: any) => userA.Nome.localeCompare(userB.Nome)
    },
    {
      title: 'S.P. totali',
      tooltip: 'Story Points totali',
      compare: (recordA: any, recordB: any) =>
        recordA.StoryPoint - recordB.StoryPoint
    },
    {
      title: 'C.W.',
      tooltip: 'Ore totali stimate per i task',
      compare: (taskA: any, taskB: any) => taskA.OreStimate - taskB.OreStimate
    },
    {
      title: 'E.T.',
      tooltip: 'Ore totali effettive per i task',
      compare: (taskA: any, taskB: any) =>
        taskA.OreEffettive - taskB.OreEffettive
    },
    {
      title: 'C.W. vs E.T.',
      tooltip: '% di discostamento dalle stime',
      compare: (resultA: any, resultB: any) =>
        resultA.DiscostamentoDalleStime - resultB.DiscostamentoDalleStime
    },
    {
      title: 'Capacity',
      tooltip: 'Ore capacity',
      compare: (capacityA: any, capacityB: any) =>
        capacityA.Capacity - capacityB.Capacity
    },
    {
      title: 'Velocity',
      tooltip: 'Story Points/Ore capacity',
      compare: (velocityA: any, velocityB: any) =>
        velocityA.Velocity - velocityB.Velocity
    },
    {
      title: 'Δ %S.P./CA.',
      tooltip: 'Δ% Story Points/Ore capacity',
      compare: (deltaA: any, deltaB: any) => deltaA.DeltaVel - deltaB.DeltaVel,
      isMonitoringPage: true
    },
    {
      title: '%S vs CA.',
      tooltip: '% di successo rispetto alle ore di capacity',
      compare: (successA: any, successB: any) =>
        successA.Successo - successB.Successo,
      isMonitoringPage: true
    },
    {
      title: 'Δ %S vs CA.',
      tooltip: 'Δ % di successo rispetto alle ore di capacity',
      compare: (deltaSuccessA: any, deltaSuccessB: any) =>
        deltaSuccessA.DeltaSuccesso - deltaSuccessB.DeltaSuccesso,
      isMonitoringPage: true
    },
    {
      title: '% Residuo',
      tooltip: '% PBI residuo',
      compare: (residueA: any, residueB: any) =>
        residueA.Residuo - residueB.Residuo,
      isReviewPage: true
    },
    {
      title: 'Progetto/i',
      isReviewPage: true
    },
    {
      title: 'N° Sprint',
      tooltip: 'N° di Sprint',
      compare: (sprintA: any, sprintB: any) =>
        sprintA.NumeroDiSprint - sprintB.NumeroDiSprint
    }
  ];

  constructor(private readonly utilityService: UtilityService) {}

  ngOnInit() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 567) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (screenWidth >= 567 && screenWidth <= 900) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.isDesktop = true;
    }
  }

  get visibleColumns() {
    if (this.isMonitoringPage) {
      // In monitoraggio: mostra tutte tranne le colonne di review
      return this.listOfColumn.filter(col => !col.isReviewPage);
    } else {
      // In review: mostra le colonne di review e quelle senza `isMonitoringPage`
      return this.listOfColumn.filter(
        col => col.isReviewPage || !col.isMonitoringPage
      );
    }
  }

  onSort(sort: { key: string; value: string }): void {
    if (this.sortKey === sort.key) {
      this.sortValue = this.sortValue === 'ascend' ? 'descend' : 'ascend';
    } else {
      this.sortKey = sort.key;
      this.sortValue = 'ascend';
    }

    const compareFn = this.listOfColumn.find(
      col => col.title === this.sortKey
    )?.compare;

    if (compareFn) {
      this.responseData = [...this.responseData].sort((a, b) => {
        const result = compareFn(a, b);
        if (this.sortValue === 'ascend') {
          return result;
        } else {
          return -result;
        }
      });
    }
  }

  onPageChange(pageIndex: number): void {
    this.currentPage = pageIndex;
    this.pageChange.emit({
      pageIndex: this.currentPage - 1,
      pageSize: this.pageSize
    });
  }

  onPageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
    this.pageChange.emit({
      pageIndex: this.currentPage - 1,
      pageSize: pageSize
    });
  }

  sanitizeImage(image: string) {
    return this.utilityService.getSanitizeUrl(image);
  }
}
